import { useMemo } from 'react';
import * as React from 'react';

import { RaceInfoType } from '@/modelTypes';

import { LargestValue, SecondLargestValue, Value } from './style';

const HighlightValue: React.FC<{
  children: number;
  numArray: number[];
  fractionDigits?: number;
  raceInfoType?: RaceInfoType;
}> = ({ children, numArray, fractionDigits, raceInfoType }) => {
  const sortNumberOfArray = (arr: number[]): number[] => {
    // 降順に並び替える
    return useMemo(() => arr.sort((a, b) => (a < b ? 1 : -1)), [arr]);
  };

  const sortedArray = sortNumberOfArray(numArray).filter(num => num > 0);

  if (raceInfoType && raceInfoType === RaceInfoType.Result) {
    return <Value>{children.toFixed(fractionDigits)}</Value>;
  }

  if (sortedArray[0] === children) {
    return <LargestValue>{children.toFixed(fractionDigits)}</LargestValue>;
  }
  if (sortedArray[1] === children) {
    return (
      <SecondLargestValue>
        {children.toFixed(fractionDigits)}
      </SecondLargestValue>
    );
  }
  return <Value>{children.toFixed(fractionDigits)}</Value>;
};

export default HighlightValue;
